




























































import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {Period} from '@/enums/Period'
import DeliveryMonthRequest from '@/model/request/DeliveryMonthRequest'
import {ItrackCollection} from '@/helpers'
import {IResource, ObjectCollection} from 'simpli-web-sdk'

@Component
export default class FilterDeliveryMonth extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryMonthRequest

  async mounted( ) {
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
